import { motion, useInView, useMotionValue, animate } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export const Reveal = ({ children, delay = 0, y = 26, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, id }) => (
  <div id={id} className="flex items-center gap-3 mb-5">
    <span className="h-px w-8 bg-gradient-to-r from-[#00E5FF] to-transparent" />
    <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#00E5FF]">{children}</span>
  </div>
);

export const Counter = ({ to, suffix = "", prefix = "", duration = 2 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const mv = useMotionValue(0);
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(mv, to, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(Math.floor(v)),
    });
    return controls.stop;
  }, [inView, to]); // eslint-disable-line

  return (
    <span ref={ref}>
      {prefix}
      {val.toLocaleString()}
      {suffix}
    </span>
  );
};

export const Glow = ({ className = "", color = "#00E5FF" }) => (
  <div
    className={`pointer-events-none absolute rounded-full blur-[120px] opacity-30 ${className}`}
    style={{ background: color }}
  />
);

const isLikelyImage = (src) => typeof src === "string" && /^(https?:)?\/\//i.test(src.trim());

export const SafeImage = ({ src, alt = "", className = "", fallbackClassName = "" }) => {
  const [err, setErr] = useState(!isLikelyImage(src));
  useEffect(() => { setErr(!isLikelyImage(src)); }, [src]);
  if (err) {
    return <div className={`bg-gradient-to-br from-[#00E5FF]/25 via-[#7B61FF]/20 to-[#00FFB2]/20 ${fallbackClassName || className}`} />;
  }
  return <img src={src} alt={alt} loading="lazy" className={className} onError={() => setErr(true)} />;
};
